// @ts-strict-ignore
import { CmsApiFormBuilderBlockData } from 'modules/cms/api/types/CmsApiFormBuilder';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpFormBuilderBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiFormBuilderBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      data={{
        ...data,
        image: data.bgImage,
        text: data.headline,
        buttonText: data.submitButtonText,
        isEmailSignup: true,
      }}
      blockId={blockId}
    />
  );
}
